module.exports = __webpack_public_path__ + "img/message-chat-circle.ce7f8bd7.svg";